import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Activează notificările WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Apeluri automate pentru comenzile în așteptare',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Program de lucru',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Locație',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identitatea restaurantului',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Timp de ridicare',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Timp de livrare',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Credențiale personal',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importă meniu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favorite',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Produse epuizate',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Coduri promoționale',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galerie',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Adaugă logo și culoare principală',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Comandă flyere',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Creează storefront',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Activează comenzile live',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Activează Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Verificați dacă proprietarul/persoana de contact are WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Verificați dacă numărul restaurantului este corect pentru a primi apeluri automate și a nu rata comenzi',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Configurați programul de lucru al restaurantului',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Configurați locația restaurantului',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Setați tipul și bucătăriile afișate pe vitrină',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Configurați setările timpului de ridicare',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Configurați setările pentru timpul de livrare',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Configurați credențialele personalului',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importați meniul de la furnizor terț',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Marcați 4 articole ca favorite. Întrebați restaurantul care sunt cele 4 preparate cele mai populare',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Configurați comportamentul articolelor epuizate',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Configurați codurile promoționale',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Actualizați galeria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Obțineți logo-ul de la restaurant sau de pe pagina restaurantului pe Lieferando. Salvați logo-ul de acolo. Alegeți culoarea predominantă din logo-ul restaurantului',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Editați designul flyerului și creați comanda',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Creați vitrina și editați site-ul dacă este necesar',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Activați comenzile live („!doar la data lansării!")',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Conectați contul Google Business',
  },
  buttons: {
    mark_as_complete: 'Marcați ca finalizat',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
  },
};
